import React, { lazy, Suspense } from 'react';
import { BottomSheetAnimatedWrapperProps } from 'mini-bottom-sheet-animated';

const LazyBottomSheetPortal = lazy(() => import('./components/BottomSheetPortal'));

export const BottomSheet: React.FC<BottomSheetAnimatedWrapperProps> = React.forwardRef(
    (props, ref?: React.RefObject<any>) => (
        <Suspense fallback={null}>
            <LazyBottomSheetPortal {...props} ref={ref} />
        </Suspense>
    )
);

export { BottomSheetAnimatedWrapperProps };
export default BottomSheet;
